import {Component, forwardRef, Injector, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';
import {ProvidersService} from '../../../phone/config/providers/services/providers.service';
import {VnaClientService} from '../../../client/management/service/vna-client.service';
import { AuthService } from 'app/core/service/auth.service';

const SELECT_VNA_CLIENT_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectVnaClientComponent)
};
@Component({
  selector: 'app-select-vna-client',
    template: `
       <div [ngClass]="{'customInvalid':!this.control.control.valid && this.submitted}">
        <ngx-select [items]="clients" [(ngModel)]="selectedValue" [optionValueField]="valueField" [optionTextField]="textField" [allowClear]="true">
                    <ng-template   ngx-select-option ngx-select-option-selected let-option let-text="text">
                      {{option.data.username}}
                    </ng-template>
                </ngx-select>
       </div>
      `,
  styleUrls: ['./select-vna-client.component.scss'],
    providers:[SELECT_VNA_CLIENT_VALUE_ACCESSOR]
})
export class SelectVnaClientComponent implements OnInit, ControlValueAccessor{

  _selectedValue:any;
  control: NgControl;
  clients: Array <any>;
  textField='username';
  @Input() id:any;
  @Input() submitted:boolean=false;
  @Input() valueField:string='pk';

  constructor(private providerService: ProvidersService, private  inj: Injector, private clientHandler: VnaClientService,
    private auth: AuthService) {}

  ngOnInit() {
      this.control = this.inj.get(NgControl);
      this.clientHandler.getClientList()
          .subscribe(result=>{
              this.clients=result;
              const pkClient = this.auth.getClient();
              if(pkClient > 0){
                this.clients = this.clients.filter( (client: any) => {
                  return client['pk'] === pkClient;
                });
              }
            })
  }
//
  get selectedValue(): any {
        return this._selectedValue;
  };

  set selectedValue(v: any) {
        this._selectedValue = v;
        this.propagateChange(this._selectedValue);
  }

  propagateChange = (_: any) => {};

  onTouched = (_: any) => {};

  registerOnChange(fn: any): void {
        this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
        this.onTouched = fn;
  }

  writeValue(value: any): void {
        this._selectedValue = value;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/select-vna-client/select-vna-client.component.ts